import { render, staticRenderFns } from "./AddEventAttendeesEx.vue?vue&type=template&id=a96bbdf4&"
import script from "./AddEventAttendeesEx.vue?vue&type=script&lang=js&"
export * from "./AddEventAttendeesEx.vue?vue&type=script&lang=js&"
import style0 from "./AddEventAttendeesEx.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports